import { render, staticRenderFns } from "./TabAnnexeCovid.vue?vue&type=template&id=33b4d721&scoped=true&"
import script from "./TabAnnexeCovid.vue?vue&type=script&lang=js&"
export * from "./TabAnnexeCovid.vue?vue&type=script&lang=js&"
import style0 from "./TabAnnexeCovid.vue?vue&type=style&index=0&id=33b4d721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4d721",
  null
  
)

export default component.exports